import { CentricTypography as Typography } from '@core/component/CentricTypography'
import classNames from 'classnames'
import { useObserver } from 'mobx-react-lite'
import React, { FC, memo } from 'react'
import { makeStyles } from '@material-ui/core'

interface IEnhancedProductSizesList {
  rowDataId: string
  showProductSizes: boolean
  getSizes: Function
}

const useStyles = makeStyles(theme => ({
  singleSize: {
    height: 32,
    display: 'flex',
    alignItems: 'center'
  },
  inactive: {
    opacity: '0.5'
  }
}))

const EnhancedProductSizesList: FC<IEnhancedProductSizesList> = ({
  rowDataId,
  showProductSizes,
  getSizes
}) =>
  useObserver(function useHook() {
    const classes = useStyles()

    if (!showProductSizes) {
      return null
    }
    return (
      <>
        {getSizes(rowDataId)?.map(({ id, name, isInactive = false }) => {
          return (
            <div
              key={id}
              className={classNames(classes.singleSize, isInactive && classes.inactive)}
            >
              <Typography variant={'body1'}>{name}</Typography>
            </div>
          )
        })}
      </>
    )
  })
export default memo(EnhancedProductSizesList)
